import { render } from "./CostList.vue?vue&type=template&id=35589e3e&scoped=true"
import script from "./CostList.vue?vue&type=script&lang=js"
export * from "./CostList.vue?vue&type=script&lang=js"

import "./CostList.vue?vue&type=style&index=0&id=35589e3e&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35589e3e"]])

export default __exports__